<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
        </ion-buttons>
        <ion-title>Kết quả</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <GameTitle game="max3dpro"></GameTitle>
      <div v-if="loaded">
        <template v-for="(stage,sid) in stages" :key="sid">
          <Max3dproResult :stage="stage"></Max3dproResult>
        </template>
        <div v-if="stages.length == 0" style="text-align:center; padding-top: 10vh">Không có dữ liệu</div>
      </div>
      <div v-else>
        <div v-for="i in 4" :key="i" class="stage">
          <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <div class="date">
              <ion-skeleton-text style="width: 30vw"></ion-skeleton-text>
            </div>
            <div>
              <ion-skeleton-text style="width: 15vw"></ion-skeleton-text>
            </div>
          </div>

          <div>
            <ion-skeleton-text style="width: 15vw; margin: 1vw auto"></ion-skeleton-text>
          </div>
          <div class="first">
            <div class="balls">
              <span class="fakeball" v-for="nid in 4" :key="nid">
                <ion-skeleton-text style="border: none; width: 6vw"></ion-skeleton-text>
              </span>
            </div>
          </div>

          <div>
            <ion-skeleton-text style="width: 15vw; margin: 1vw auto"></ion-skeleton-text>
          </div>
          <div class="second">
            <div v-for="r in 2" :key="r" class="balls">
              <span class="fakeball" v-for="nid in 4" :key="nid">
                <ion-skeleton-text style="border: none; width: 6vw"></ion-skeleton-text>
              </span>
            </div>
          </div>

          <div>
            <ion-skeleton-text style="width: 15vw; margin: 1vw auto"></ion-skeleton-text>
          </div>
          <div class="third">
            <div v-for="r in 3" :key="r" class="balls">
              <span class="fakeball" v-for="nid in 4" :key="nid">
                <ion-skeleton-text style="border: none; width: 6vw"></ion-skeleton-text>
              </span>
            </div>
          </div>

          <div class="csl">
            <div>
              <div>
                <ion-skeleton-text style="width: 25vw; margin: 1vw auto"></ion-skeleton-text>
              </div>
              <div class="balls" style="border:none">
                <span class="fakeball" v-for="nid in 4" :key="nid">
                  <ion-skeleton-text style="border: none; width: 6vw"></ion-skeleton-text>
                </span>
              </div>
            </div>
            <div>
              <div>
                <ion-skeleton-text style="width: 25vw; margin: 1vw auto"></ion-skeleton-text>
              </div>
              <div class="balls">
                <span class="fakeball" v-for="nid in 4" :key="nid">
                  <ion-skeleton-text style="border: none; width: 6vw"></ion-skeleton-text>
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </ion-content>
  </ion-page>

</template>

<style scoped>
  .stage {
    padding: 2vw;
    border-bottom: 1px solid #ddd;
    text-align: center;
  }

  .stage .date {
    text-transform: capitalize;
  }

  .stage .balls {
    display: flex;
    flex-direction: row;
    padding: 0.5vw 1.5vw;
    border-left: 1px solid #ccc;
    margin: 0.5vh 1vw;
    margin-right: 0;
    padding-right: 0;
  }

  .stage .balls:first-child {
    border: none;
  }

  .stage .balls .fakeball {
    border: none;
  }

  .stage .balls .ball, .fakeball {
    width: 6vw;
    height: 6vw;
    border-radius: 50%;
    border: 1px solid #ccc;
    font-size: 0.9em;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1px;
  }

  .stage .csl1.balls .ball:nth-child(1) {
    color: #999;
  }

  .stage .csl2.balls .ball:nth-child(1), .stage .csl2.balls .ball:nth-child(2) {
    color: #999;
  }

  .stage .first, .stage .second {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .stage .third {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;
  }

  .stage .csl {
    display: grid;
    grid-template-columns: repeat(4, auto);
    justify-content: center;
  }

  .stage .first .balls .ball {
    background: #d00;
    border-color: #d00;
    color: #fff;
  }

  .stage .second .balls .ball {
    background: #66106F;
    border-color: #66106F;
    color: #fff;
  }
  .stage .third .balls .ball {
    background: #a59600;
    border-color: #a59600;
    color: #fff;
  }

  .stage .csl .balls .ball {
    color: #c00;
    border: 1px solid #999
  }

  .stage .csl .balls:first-child .ball {
    color: #999;
  }

</style>

<script>
  import GameTitle from '@/components/GameTitle';
  import { defineComponent } from 'vue';
  import Max3dproResult from '@/components/results/Max3dpro.vue';
  import {
    IonPage,
    IonContent,
    IonHeader,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonToolbar,
    IonSkeletonText,
    IonLabel,
  } from '@ionic/vue';

  export default defineComponent({
    components: {
      IonPage,
      IonContent,
      IonHeader,
      IonButtons,
      IonBackButton,
      IonTitle,
      IonToolbar,
      GameTitle,
      IonSkeletonText,
      Max3dproResult,
      IonLabel,
    },
    data() {
      return {
        loaded: false,
        stages: [],
      }
    },
    mounted() {
      setTimeout(() => {
        this.$utils.callAPI("GET", "/stages/results", { 'game': "max3dpro" }, false).then(resp => {
          resp.data.stages.forEach((stage) => {
            stage.results = JSON.parse(stage.results).numbers;
          });
          this.stages = resp.data.stages;
          console.log(this.stages);
          this.loaded = true;
        });
      }, 1000);
    }
  });
</script>

